import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../../admin_resources/css/admin_layout.css";
import "../../../admin_resources/css/admin_common.css";
import "../../../admin_resources/css/admin_style.css";
import ADMIN_HEADER from "../Admin_Header";
import "react-datepicker/dist/react-datepicker.css";
import { ko } from "date-fns/locale"; // 한국어 locale 추가
import { registerLocale } from "react-datepicker";

registerLocale("ko", ko); // 한국어 locale 등록

const Admin_Swrite = () => {
  const [title, setTitle] = useState("");
  const [snsType, setSnsType] = useState("youtube");
  const [selectedFileName, setSelectedFileName] = useState(""); // file2의 선택된 파일 이름
  const [, setFile1Name] = useState(""); // file1 이름 상태
  const [, setFile2] = useState(null); // file2 상태
  const [url1, setUrl1] = useState("");
  const [content, setContent] = useState("");
  
  const [permissions, setPermissions] = useState({});
  
  useEffect(() => {
    // 관리자 권한 정보 가져오기
    const adminId = localStorage.getItem("adminId");
    if (adminId) {
      fetchPermissions(adminId);
    }
  });

  const fetchPermissions = async (adminId) => {
    try {
      const response = await fetch(`/permissions/${adminId}`); // 권한 확인 API 호출
      const data = await response.json();
      setPermissions(data); // 권한 정보를 상태로 설정
    } catch (error) {
      console.error("권한 정보를 가져오는 데 실패했습니다.", error);
    }
  };

  // snstype 라디오 버튼 값 변경
  const handleNoticeChange = (event) => {
    setSnsType(event.target.value);
  };

  // 이미지 크기 체크 함수
  const checkImageSize = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = function () {
        if (img.width === 300 && img.height === 300) {
          resolve();
        } else {
          reject("이미지 크기는 300x300이어야 합니다.");
        }
      };
      img.onerror = function () {
        reject("이미지 로드 오류");
      };
      img.src = URL.createObjectURL(file);
    });
  };

  // 파일 선택 함수
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    // 파일이 선택되었을 때
    if (file) {
      setSelectedFileName(file.name);
      const timestamp = new Date()
        .toISOString()
        .replace(/[-:.T]/g, "")
        .slice(0, 14);
      const extension = file.name.split(".").pop();
      setFile1Name(`${timestamp}_.${extension}`); // file1 이름 상태 업데이트
      setFile2(file); // file2 상태 업데이트

      // 이미지 크기 체크
      checkImageSize(file)
        .then(() => {
          console.log("이미지 크기 확인 통과");
        })
        .catch((errorMessage) => {
          alert(errorMessage); // 크기가 맞지 않으면 알림 띄우기
          setFile2(null); // 잘못된 파일을 상태에서 제거
          setSelectedFileName(""); // 파일 이름 초기화
          // 파일 입력란을 초기화
          fileInputRef.current.value = ""; // useRef로 파일 입력란 초기화
        });
    } else {
      setSelectedFileName("");
      setFile1Name(""); // 파일이 선택되지 않은 경우
      setFile2(null); // 잘못된 파일 상태 초기화

      // 파일 입력란 초기화
      fileInputRef.current.value = ""; // useRef로 파일 입력란 초기화
    }
  };

  const fileInputRef = useRef(null); // useRef로 파일 입력란에 대한 참조를 생성

  // 폼 제출 처리
  const handleSubmit = async (e) => {
    e.preventDefault();

    // 등록 확인 창을 띄우기 전에 필수 입력 항목 체크
    if (!title) {
      alert("제목은 필수 입력항목 입니다");
      return;
    }

    // 등록 확인 알림창
    const isConfirmed = window.confirm("등록하시겠습니까?");

    if (!isConfirmed) {
      return; // 사용자가 취소를 선택하면 폼 제출을 중단
    }

    const formData = new FormData();
    formData.append("memId", localStorage.getItem("adminId"));
    formData.append("name", localStorage.getItem("adminName"));
    formData.append("title", title);
    formData.append("content", content);
    formData.append("gubun", "BB07");
    formData.append("snsType", snsType);
    formData.append("url1", url1);

    try {
      const response = await fetch("/boardForm", {
        method: "POST",
        body: formData,
      });

      console.log("Response Status: ", response.status);

      if (!response.ok) {
        const errorText = await response.text(); // 서버에서 반환된 에러 메시지 확인
        console.error("Error response text:", errorText);
        throw new Error("네트워크 응답이 올바르지 않습니다.");
      }

      alert("소셜 등록이 완료되었습니다.");
      window.location.href = "/admin/board/social";
    } catch (error) {
      console.error("에러 발생:", error);
      alert("소셜 등록 중 오류가 발생했습니다.");
    }
  };

  return (
    <div>
      <ADMIN_HEADER />
      <div className="admin_write">
        <div className="path-sec">
          HOME &gt; <span className="menu1">게시판 관리</span> &gt;
          <span className="menu2"> 아소비 소셜 관리</span>
        </div>
        <table>
          <tr>
            <td>
              <div className="sec-snb">
                <h3 className="snb_tit">게시판 관리</h3>
				<ul className="snb_list">
				  {permissions.notice && (
				    <li>
				      <a href="/admin/board/notice">아소비소식 관리</a>
				    </li>
				  )}
				  {permissions.event && (
				    <li>
				      <a href="/admin/board/event">아소비이벤트 관리</a>
				    </li>
				  )}
				  {permissions.social && (
				    <li className="cur">
				      <a href="/admin/board/social">아소비 소셜 관리</a>
				    </li>
				  )}
				  {permissions.magazine && (
				    <li>
				      <a href="/admin/board/magazine">아소비 꿀지 관리</a>
				    </li>
				  )}
				</ul>
              </div>
            </td>
            <td>
              <div className="bx-top">아소비 소셜 등록</div>
              <form
                id="writeform"
                method="post"
                encType="multipart/form-data"
                onSubmit={handleSubmit}
              >
                <div className="tb_01 wr">
                  <table>
                    <tbody>
                      <input type="hidden" name="gubun" value="BB07" />
                      <tr>
                        <th>제목</th>
                        <td>
                          <input
                            name="title"
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="여기에 제목을 입력하세요"
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>소식 타입</th>
                        <td>
                          <label>
                            <input
                              type="radio"
                              value="youtube"
                              name="snsType"
                              checked={snsType === "youtube"}
                              onChange={handleNoticeChange}
                            />
                            유튜브
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="instagram"
                              name="snsType"
                              checked={snsType === "instagram"}
                              onChange={handleNoticeChange}
                            />
                            인스타그램
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="cafe"
                              name="snsType"
                              checked={snsType === "cafe"}
                              onChange={handleNoticeChange}
                            />
                            아소비카페
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="blog"
                              name="snsType"
                              checked={snsType === "blog"}
                              onChange={handleNoticeChange}
                            />
                            블로그
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <th>썸네일 이미지</th>
                        <td>
                          <label className="file">
                            <input
                              id="upload"
                              name="file2"
                              type="file"
                              className="inputtext"
                              onChange={handleFileChange}
                              ref={fileInputRef}
                            />
                            <i>파일 선택 : </i>
                            <span>
                              {selectedFileName || "선택된 파일 없음"}
                            </span>
                          </label>
                          <p className="ps">※ 첨부파일 300px X 300px</p>
                        </td>
                      </tr>
                      <tr>
                        <th>링크</th>
                        <td>
                          <input
                            name="url1"
                            type="text"
                            value={url1}
                            onChange={(e) => setUrl1(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>내용 입력</th>
                        <td>
                          <textarea
                            name="content"
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                          ></textarea>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="view-btn">
                    <span className="btn custom_s">
                      <button>
                        <Link
                          to="/admin/board/social"
                          style={{ color: "#fff" }}
                        >
                          목록
                        </Link>
                      </button>
                    </span>

                    <div className="btn-right">
                      <span className="btn custom_r">
                        <button type="submit" className="submit-btn">
                          등록
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </form>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default Admin_Swrite;
